import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import {
  TICKETS_BY_USER_URL,
  TICKETS_BY_RESOLVER_GROUP_URL,
  TICKETS_BY_RESOLVER_URL,
} from "../../Constants/Constants";
import { MERGED } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "./../alerts//AlertContext";
import AssignTicket from "./AssignTicket";
import MergeTicketDialog from "./MergeTicketDialog";
import TicketDialog from "./TicketDialog";
import AppTableView from "../AppTableView";
import Grid from "@mui/material/Grid2";
import { IconButton, TextField, MenuItem } from "@mui/material";
import { TICKETS_COLUMNS } from "./grid/GridDataConstants";
import { TICKETS } from "../../Constants/RolesConstants";
import { USER_ID } from "../../Constants/StorageConstants";
import FiltersDialog from "./FiltersDialog";
const DEFAULT_SORT_PARAMS = {
  field: "createdOn",
  sort: "desc",
};

function Tickets({ permissions, userRole }) {
  const [type, setType] = useState("bug");
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      //backgroundColor: theme.palette.common.blue,
      backgroundColor: "#1976d2",
      color: theme.palette.common.white,
      paddingTop: 2,
      paddingBottom: 2,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 12,
      paddingTop: 2,
      paddingBottom: 2,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const location = useLocation();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);

  const [tickets, setTickets] = useState([]);
  const [cursor] = useState("pointer");
  const initialized = useRef(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [totalElements, setTotalElements] = useState(0);

  const [paginationData, setPaginationData] = useState({
    page: 0,
    rowsPerPage: 15,
  });

  const [sortParams, setSortParameters] = useState([]);

  const TicketFilterURLs = {
    assignedToMe: TICKETS_BY_RESOLVER_URL,
    resolverGroup: TICKETS_BY_RESOLVER_GROUP_URL,
    myTickets: TICKETS_BY_USER_URL,
  };

  const setPaginationParams = ({ page, pageSize }) => {
    setPaginationData((prevState) => {
      const { page: prevPage, rowsPerPage: prevPageSize } = prevState || {};

      if (!page && !pageSize) {
        return {
          page: 0,
          rowsPerPage: prevPageSize || 20,
        };
      }

      if (prevPageSize === pageSize && prevPage === page) {
        return prevState;
      }

      if (prevPageSize !== pageSize) {
        return {
          page: 0,
          rowsPerPage: pageSize,
        };
      }

      return {
        page,
        rowsPerPage: pageSize,
      };
    });
  };

  const setSortParams = (sortParams) => {
    if (sortParams.length !== 0) {
      setPaginationParams({ page: 0 });
    }
    setSortParameters(sortParams);
  };

  const fetchTickets = (URL, statusId) => {
    setLoading(true);
    const { field: fieldName, sort: sortDirection } =
      sortParams.length > 0 ? sortParams[0] : DEFAULT_SORT_PARAMS;

    AxiosInstance.post(URL, {
      page: paginationData.page,
      size: paginationData.rowsPerPage,
      direction: sortDirection,
      sort: fieldName,
      search: "",
      statusId: statusId,
      userId: localStorage.getItem(USER_ID),
    })
      .then((response) => {
        setTickets(response.data.content);
        setTotalElements(response.data.totalElements);
        setLoading(false);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    //  const loadData = async () => {
    //   try {
    //     setLoading(true);
    //     if (!initialized.current) {
    //       initialized.current = true;
    //       await getTickets();
    //     }                 // set your data
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     setLoading(false);                  // stop loading AFTER data
    //   }
    // };

    // loadData();
    if (location.state?.openTicketDialog) {
      setOpenDialog(true);

      navigate(location.pathname, {
        replace: true,
        state: {}
      });
    }

    fetchTickets(TICKETS_BY_USER_URL, null);
  }, [sortParams, paginationData, location.state]);

  //const [order, setOrder] = React.useState<Order>('asc');
  //const [orderBy, setOrderBy] = React.useState<keyof Data>('calories');
  //const [selected, setSelected] = React.useState<readonly number[]>([]);

  const showAlert = useAlert();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const getTickets = async () => {
  //   setSelectedItems([]);
  //   var userId = localStorage.getItem("id");
  //   await AxiosInstance.get(USER_TICKETS_URL + userId).then((response) =>
  //     setTickets(response.data)
  //   );
  // };

  const handleCheckboxChange = (item) => {
    setSelectedItems((prev) => {
      const isSelected = prev.some((obj) => obj.id === item.id);
      return isSelected
        ? prev.filter((obj) => obj.id !== item.id)
        : [...prev, item];
    });
  };

  const handleNavigation = (event, mergeTicket) => {
    if (mergeTicket !== "" && mergeTicket !== null && mergeTicket !== MERGED) {
      showAlert("This ticket merged to " + mergeTicket, "info");
      event.preventDefault(); // Stop navigation if validation fails
    }
  };

  const visibleRows = React.useMemo(
    () =>
      [...tickets].slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [tickets, page, rowsPerPage]
  );

  const getTicketsByIds = (ids) => {
    return tickets.filter((ticket) => ids.includes(ticket.id));
  };

  const rowSelectableFunction = function rowSelection(ticket) {
    const mergeTicketStatus = ticket.mergeTicket || "";
    return mergeTicketStatus === "" || mergeTicketStatus === MERGED;
  };

  const handleSelectedItemsInTable = (itemSelectedIds) => {
    setSelectedItems(itemSelectedIds);
  };

  const tableMetaData = {
    page: paginationData.page || 0,
    pageSize: paginationData.rowsPerPage || 20,
    sortParams,
  };
  return (
    <Container fluid>
      <Box
        sx={{
          padding: 2,
          paddingTop: 0,
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          gap: 1,
        }}
      >
        {/* <TextField
          id="ticket-filter"
          select
          label="Tickets Filter"
          defaultValue="myTickets"
          variant="standard"
          onChange={(e) =>{ 
            setType(e.target.value);            
            if(e.target.value === 'assignedToMe')
              fetchTickets(TICKETS_BY_RESOLVER_URL);               
            else if(e.target.value === 'resolverGroup')
              fetchTickets(TICKETS_BY_RESOLVER_GROUP_URL); 
            else
              fetchTickets(TICKETS_BY_USER_URL);
          }}
          sx={{ width: 300 }}
        >
          <MenuItem value="assignedToMe">Tickets Assigned to Me</MenuItem>
          <MenuItem value="resolverGroup">My Resolver Group Tickets</MenuItem>
          <MenuItem value="myTickets">My Tickets</MenuItem>
        </TextField> */}
        <Box>
          <FiltersDialog
            filterTickets={fetchTickets}
            ticketFilterURLs={TicketFilterURLs}
          />
          <TicketDialog            
            callTickets={() => fetchTickets(TICKETS_BY_USER_URL, null)}
            componentPermissions={permissions[TICKETS]}
            openDialog={openDialog}
            onClose={() => setOpenDialog(false)}
          />
          <AssignTicket
            mergeTicketsDataIds={selectedItems}
            getTickets={getTicketsByIds}
            callTickets={() => fetchTickets(TICKETS_BY_USER_URL, null)}
            componentPermissions={permissions[TICKETS]}
            userRole={userRole}
          />
          <MergeTicketDialog
            mergeTicketsDataIds={selectedItems}
            getTickets={getTicketsByIds}
            callTickets={() => fetchTickets(TICKETS_BY_USER_URL, null)}
            componentPermissions={permissions[TICKETS]}
            userRole={userRole}
          />
        </Box>
      </Box>

      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          {loading ? (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              minHeight="300px"
              mt={4}
              mb={4}
            >
              <CircularProgress size={48} thickness={4} color="primary" />
              <Box mt={2} color="text.secondary" fontSize={16}>
                Loading tickets, please wait...
              </Box>
            </Box>
          ) : (
            <Grid gap={2} container spacing={2} columns={12}>
              <Grid size={{ xs: 12, lg: 12 }}>
                <AppTableView
                  rows={tickets}
                  cols={TICKETS_COLUMNS}
                  checkboxSelection={true}
                  setPaginationModel={setPaginationParams}
                  setSortModel={setSortParams}
                  paramsData={tableMetaData}
                  totalElements={totalElements}
                  paginationMode="server"
                  sortMode="server"
                  hasRowSelectableFn={rowSelectableFunction}
                  handleRowSelection={handleSelectedItemsInTable}
                />
              </Grid>
            </Grid>
            // <>
            //   <TableContainer component={Paper}>
            //     <Table sx={{ minWidth: 700 }} aria-label="customized table">
            //       <TableHead>
            //         <TableRow>
            //           <StyledTableCell></StyledTableCell>
            //           <StyledTableCell>Ticket Number</StyledTableCell>
            //           <StyledTableCell>Priority</StyledTableCell>
            //           <StyledTableCell>Impact</StyledTableCell>
            //           <StyledTableCell>Urgency</StyledTableCell>
            //           <StyledTableCell>Category</StyledTableCell>
            //           <StyledTableCell>Request Type</StyledTableCell>
            //           {/* <StyledTableCell>Created By</StyledTableCell> */}
            //           <StyledTableCell>Status</StyledTableCell>
            //           <StyledTableCell>Resolver Group</StyledTableCell>
            //           <StyledTableCell>Resolver</StyledTableCell>
            //           {/* <StyledTableCell>Modified On</StyledTableCell>                     */}
            //         </TableRow>
            //       </TableHead>
            //       <TableBody>
            //         {tickets.map((ticket, index) => {
            //           return (
            //             <StyledTableRow key={ticket.id}>
            //               <StyledTableCell>
            //                 <Checkbox
            //                   color="primary"
            //                   id={ticket.id}
            //                   disabled={
            //                     ticket.mergeTicket !== "" &&
            //                     ticket.mergeTicket !== null &&
            //                     ticket.mergeTicket !== MERGED
            //                       ? true
            //                       : false
            //                   }
            //                   //checked={selectedItems.includes({'id':ticket.id,'mergeTicket': ticket.mergeTicket})}
            //                   checked={selectedItems.some(
            //                     (obj) => obj.id === ticket.id
            //                   )}
            //                   //checked={(selectedIds) => selectedIds.filter((item) => item.id !== ticket.id).includes({'id':ticket.id,'mergeTicket': ticket.mergeTicket})}
            //
            //                   onChange={() =>
            //                     handleCheckboxChange({
            //                       id: ticket.id,
            //                       mergeTicket: ticket.mergeTicket,
            //                       category: ticket.ticketCategory.id,
            //                     })
            //                   }
            //                 />
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 <Link
            //                   to={`/editTicket/${ticket.id}`}
            //                   onClick={(event) =>
            //                     handleNavigation(event, ticket.mergeTicket)
            //                   }
            //                 >
            //                   {ticket.id}
            //                 </Link>
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket.priority.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket.impact.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket.urgency.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket.ticketCategory?.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket.requestType.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket?.status?.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket?.resolverGroup?.name}
            //               </StyledTableCell>
            //               <StyledTableCell>
            //                 {ticket?.resolver?.name}
            //               </StyledTableCell>
            //             </StyledTableRow>
            //           );
            //         })}
            //       </TableBody>
            //     </Table>
            //   </TableContainer>
            //   <TablePagination
            //     component="div"
            //     count={totalElements}
            //     page={page}
            //     onPageChange={(event, newPage) => setPage(newPage)}
            //     rowsPerPage={rowsPerPage}
            //     onRowsPerPageChange={(e) => {
            //       setRowsPerPage(parseInt(e.target.value, 10));
            //       setPage(0);
            //     }}
            //     rowsPerPageOptions={[15, 50, 100]}
            //   />
            // </>
          )}
        </Paper>
      </Box>

      {/* </fieldset> */}
    </Container>
  );
}

export default Tickets;
